export default "__VITE_ASSET__BCLFWc$a__"